import React, { useState } from "react";
import InstructorForm from "./InstructorForm";
import apiClient from "../../utils/apiClient";
import { useNavigate } from "react-router-dom";
import './Instructors.scss';

const initialForm = {
  name: "",
  email: "",
  mobile: "",
  gender: "",
  dob: "",
  avatar: "",
  address: "",
  qualification: "",
  experience: "",
  subject: "",
  otherSkills: "",
  linkedin: "",
  status: "Active",
  about: "",
  joinedDate: "",
  active: true,
};

const AddInstructorPage = () => {
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAdd = async (formData) => {
    setLoading(true);
    try {
      await apiClient.post("/instructors/add", formData);
      setToast({ show: true, message: "Instructor added successfully!", type: "success" });
      setTimeout(() => navigate("/instructors"), 1200);
    } catch {
      setToast({ show: true, message: "Failed to add instructor.", type: "error" });
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="container-fluid px-0 px-md-4">
        <InstructorForm
          initialData={initialForm}
          loading={loading}
          toast={toast}
          setToast={setToast}
          mode="add"
          onSubmit={handleAdd}
          onCancel={() => navigate("/instructors")}
        />
      </div>
    </div>
  );
};

export default AddInstructorPage;
